import OAuthCallback from '../components/oauth/OAuthCallback'
import OAuthLoginCallback from '../components/oauth/OAuthLoginCallback.jsx'

export const CallbacksRoutes =  [
    {
        path: 'callback',
        element: <OAuthCallback />
    }
]